module.exports = __webpack_public_path__ + "static/media/product-placeholder.1c520709.png";